const styles = (theme) => ({
  root: {},

  summary: {
    '& a': {
      textDecoration: 'none',
    },
  },
});

export default styles;
